import React from 'react';
import DataGrid from '@dataGrid';
import TrailersGridConfig from './GridConfig';
import { withUserProfile } from '../../../../../../userProfile/userProfileContext';
import { compose } from 'recompose';
import { withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import styles from '../../styles';
import StatusBar from '@dataGrid/components/StatusBar';
import { getFilteredData } from '../../../../../common/filterUtilities';
import { isEqual } from 'lodash/lang';
import Events from '../../../../../../utilities/EventEmitter';
import { withFeatureFlags } from '../../../../../../userProfile/featureFlagsContext';
import appConstants from '../../../../../../appConstants';

class TrailersGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new TrailersGridConfig({
      showTrailerScacColumn: this.props.showTrailerScac,
      showTrailerScacValue : this.props.featureFlags.isFeatureEnabled(
        appConstants.features.ShowTrailerScac
      ),
      userConfig: this.props.userData.userProfile?.columnPref
    });
    this.state = {
      quickFilter: ''
    };
  }
  componentDidMount() {
    this.props.glEventHub.on('UpdateDispatchTrailerQuickFilter', this.updatedQuickFilter);
    Events.on('RefreshTrailersData', this.updateTrailerList);
    Events.on('AssetUpdateDefects', this.updateTrailerDefects);
  }

  componentWillUnmount() {
    this.props.glEventHub.off('UpdateDispatchTrailerQuickFilter', this.updatedQuickFilter);
    Events.off('RefreshTrailersData', this.updateTrailerList);
    Events.off('AssetUpdateDefects', this.updateTrailerDefects);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.selectedAssets, prevProps.selectedAssets)) {
      this.updateSelection();
    }
  }

  constructStatusBar = (filteredData) => {
    return [
      {
        label: filteredData.length + ' Trailers',
        filterCondition: ''
      }
    ];
  };

  updatedQuickFilter = (quickFilter) => {
    this.setState({
      quickFilter
    });
  };

  updateSelection = () => {
    if (this.gridApi) {
      this.gridApi.forEachNode((node) => {
        if (this.props.selectedAssets?.includes(node.data.trailerId)) {
          this.gridApi.ensureIndexVisible(node.rowIndex);
          node.setSelected(true, false, true);
        } else {
          node.setSelected(false, false, true);
        }
      });
      this.gridApi.dispatchEvent({
        type: 'selectionChanged',
        api: this.gridApi
      });
    }
  };

  getFilteredTrailers = () => {
    if (!this.state.quickFilter) {
      return this.props.trailerList || [];
    }
    return getFilteredData(this.props.trailerList, this.state.quickFilter);
  };

  onSelectionChanged = () => {
    if (this.props.assetSelectedOnGrid && this.gridApi) {
      const selectedTrailer = this.gridApi.getSelectedRows().map((trailer) => trailer);
      this.props.assetSelectedOnGrid(selectedTrailer);
    }
  };

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.props.setGridApi(api);
  };

  updateTrailerList = (data) => {
    this.props.updateEquipmentList({
      equipmentNumber: data?.trailerNumber,
      equipmentId: data?.trailerId,
      success: data.success || false
    });
  };

  updateTrailerDefects = ({ trailer }) => {
    if (trailer) {
      this.updateTrailerList({ ...trailer, success: true });
    }
  };

  onModelUpdated = () => {
    const isQuickFilterPresent = this.gridApi.isQuickFilterPresent();
    const isColumnFilterPresent = this.gridApi.isColumnFilterPresent();
    if (isColumnFilterPresent && (this.state.quickFilter || isQuickFilterPresent)) {
      this.gridApi.onFilterChanged(); //Recalculating grid status count upon search/quick filter change when an advanced filter is present.
    }
  };

  render() {
    const trailersList = this.getFilteredTrailers();
    const { classes, searchText, showErrorMessage, isAssetUpdateFormOpen } = this.props;
    return (
      <div className={classes.dataGrid}>
        <DataGrid
          onGridReady={this.onGridReady}
          defaultColDef={this.gridConfig.config.defaultColDef}
          columnDefs={this.gridConfig.config.columns}
          columnTypes={this.gridConfig.config.columnTypes}
          config={this.gridConfig.config}
          rowSelection={this.gridConfig.config.rowSelection}
          rowDeselection={this.gridConfig.config.rowDeselection}
          rowData={trailersList}
          onRowDataUpdated={this.updateSelection}
          onSelectionChanged={this.onSelectionChanged}
          deltaRowDataMode={true}
          getRowId={(params) => params.data.trailerId}
          panelLabel={(filteredData) => <StatusBar data={this.constructStatusBar(filteredData)} />}
          isExternalFilterPresent={() => false}
          quickFilterText={searchText}
          showErrorMessage={showErrorMessage}
          suppressRowClickSelection={isAssetUpdateFormOpen}
          onModelUpdated={this.onModelUpdated}
        />
      </div>
    );
  }
}
export default compose(withUserProfile, withSnackbar,withFeatureFlags, withStyles(styles))(TrailersGrid);
